module.exports = __webpack_public_path__ + "img/icon2.246f8e3c.png";